import React from 'react';
import PropTypes from 'prop-types';

import { PieChart, Pie, ResponsiveContainer, Cell, Legend, Tooltip } from 'recharts';

import YRTooltip from 'components/year-review/components/tooltip/YRTooltip';
import YRCustomLabel from 'components/year-review/components/piechart/YRCustomLabel';
import YRCustomPieLegend from 'components/year-review/components/piechart/YRCustomPieLegend';

import Config from 'components/year-review/constants/config';
import Colors from 'components/year-review/constants/colors';

const YRPieChart = ({
    data, style, isReady,
}) => {
    const {
        pieSize,
        legendValue,
        label,
        legend,
        color,
        tooltipSuffix,
    } = style;

    let pieDiameter;
    if (pieSize) {
        switch (pieSize) {
            case 'MEDIUM':
                pieDiameter = 200;
                break;
            case 'SMALL':
                pieDiameter = 140;
                break;
            default:
                pieDiameter = 350;
        }
    }

    return (
        <ResponsiveContainer width="100%" height={Config.chartHeight}>
            <PieChart
                width={pieDiameter}
                height={pieDiameter}
                margin={{
                    top: Config.margin,
                    bottom: Config.margin,
                    left: Config.pieChartMargin,
                    right: Config.pieChartMargin,
                }}
                focusable="false"
            >
                <Tooltip
                    content={
                        <YRTooltip suffix={tooltipSuffix} />}
                />
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    fill="#8884d8"
                    dataKey="values"
                    label={label ? <YRCustomLabel
                        data={data}
                        colors={color || Colors.dnsColorsArray}
                    /> : null}
                    animationBegin={Config.animationBegin}
                    animationDuration={Config.animationDuration}
                    animationEasing={Config.animationEasing}
                    key={isReady ? 0 : 1}
                >
                    {
                        data.map((element, index) => (
                            <Cell
                                fill={color ? color[index] : Colors.dnsColorsArray[index]}
                                stroke={color ? color[index] : Colors.dnsColorsArray[index]}
                                key={`cell-${element.name}`}
                            />
                        ))
                    }
                </Pie>
                {legend && (legendValue ?
                    <Legend
                        content={<YRCustomPieLegend style={style} />}
                    />
                    :
                    <Legend
                        payload={
                            data.map((element, index) => (
                                {
                                    value: element.name, type: 'circle', color: color ? color[index] : Colors.dnsColorsArray[index],
                                }
                            ))
                        }
                    />)}
            </PieChart>
        </ResponsiveContainer>
    );
};

YRPieChart.defaultProps = {
    style: {},
};

YRPieChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    isReady: PropTypes.bool.isRequired,
    style: PropTypes.objectOf(PropTypes.any),
};

export default YRPieChart;
